module.exports = __webpack_public_path__ + "fonts/fa-solid-900.93f28454.woff";